import {inject, injectable} from "inversify";
import {GameSlot} from "@/modules/main-menu/entity";
import {Season} from "@/modules/season/entity";
import {Team} from "@/modules/team/entity";
import {waitMinimumFor} from "@/utils";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {db as mainMenuDb} from "@/modules/main-menu/services/db";
import {db} from "@/modules/base/services/db";
import {exportDataSource, persistDataSource} from "@/modules/database/services/db";

@injectable()
export default class GameSaver {
  constructor(
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {}

  public async save(options: { gameSlot?: GameSlot | null, autoSave?: boolean }) {
    await waitMinimumFor(
      this.configRepository.get('general.auto_save.minimum_wait_for'),
      async () => {
        const season = await Season.current();
        const team = await Team.current();
        const gameDbDump = await exportDataSource(db);

        const gameSlot = options.gameSlot ?? new GameSlot();
        gameSlot.autoSave = !!options.autoSave;
        gameSlot.gameDbDump = gameDbDump;
        gameSlot.seasonId = season.id;
        gameSlot.gameDateAt = season.currentDateRaw;
        gameSlot.teamName = team.name;
        await gameSlot.save();
        
        await persistDataSource(mainMenuDb);
      }
    );
  }
}
